import React from 'react';
import ObjetivosOptimizacionesAnimation from '../ui/ObjetivosOptimizacionesAnimation';

const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <div className="hidden md:flex md:w-1/2 relative overflow-hidden justify-center items-center">
        <div className="w-[700px] aspect-square relative overflow-hidden rounded-2xl mx-auto">
          <ObjetivosOptimizacionesAnimation />
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="max-w-md w-full space-y-8">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
